/*
===============================================================================================================
                                 Copyright 2025-2026, Blue Yonder Group, Inc.
                                              All Rights Reserved

                                THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
                                            BLUE YONDER GROUP, INC.

                            The copyright notice above does not evidence any actual
                                 or intended publication of such source code.

===============================================================================================================
*/

import apiClient from '@/utilities/api-client';

export const getAdminConfig = async ({ carrier, token }) => {
  const authHeaders = {
    headers: {
      Authorization: token,
    },
  };

  let adminConfig = {};
  try {
    const adminConfigData = await apiClient.get(`config/ADMIN/companyId/companyId/${carrier}`, authHeaders);

    adminConfig = adminConfigData.data?.resource?.config;
  } catch (error) {
    if (error.status === 403) {
      throw new Error('constants.apiErrors.permissions');
    }

    throw new Error(error.message);
  }

  return {
    data: adminConfig,
  };
};

export default getAdminConfig;
